/**
 * Icon elements — public API re-exports.
 *
 * Consumers import from here; internal structure (registry, types, defs/)
 * is an implementation detail.
 */

export { iconNames, iconNameSet } from './registry';
export type { IconName } from './registry';
export type { IconPathDef, IconDef } from './types';
export { iconDefs } from './defs';
